export default __webpack_public_path__ + "static/media/social-media-twitter.e215dd7a.svg";